import { render, staticRenderFns } from "./PromotionImage.vue?vue&type=template&id=0fb52d12&scoped=true"
import script from "./PromotionImage.vue?vue&type=script&lang=js"
export * from "./PromotionImage.vue?vue&type=script&lang=js"
import style0 from "./PromotionImage.vue?vue&type=style&index=0&id=0fb52d12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb52d12",
  null
  
)

export default component.exports